import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  addToJourney,
  getOrderInfo,
  getRequestInfo,
  scheduleEarliestDate,
  sendUserNotification,
} from "../../../../utilities";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { Button } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import NumbersIcon from "@mui/icons-material/Numbers";
import WorkIcon from "@mui/icons-material/Work";
import HomeIcon from "@mui/icons-material/Home";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import {
  RequestActionShell,
  SectionLabel,
  Field,
  NotesInput,
  datePickerClass,
} from "../../../../components/WindowDoor/Requests/RequestActionUI";

const iconProps = { fontSize: 16 };

const ScheduleEarliest = () => {
  const { ref } = useParams();
  const [notes, setNotes] = useState("");
  const navigate = useNavigate();
  const [requestData, setReqData] = useState("");
  const [dateSelected, setDate] = useState(new Date());
  const [dateFormatted, setFormattedDate] = useState(
    dateSelected.toLocaleDateString("en-US")
  );

  const [data, setData] = useState("");

  useEffect(() => {
    getOrderInfo(ref, setData);
    getRequestInfo(ref, setReqData);
  }, []);

  const handleSchedule = () => {
    scheduleEarliestDate(ref, notes, dateFormatted);
    sendUserNotification(
      requestData?.requestEmail,
      "System",
      `Your Request For Order #${requestData.salesOrder} Has Been Scheduled For ${dateFormatted}`,
      "Earliest Request Scheduled"
    );
    addToJourney(dateFormatted.replaceAll("/", "-"), requestData.orderID);
    navigate("/windowdoor/admin/requestlist");
  };

  return (
    <RequestActionShell
      title="Schedule Earliest Delivery"
      accent="emerald"
      icon={EventAvailableOutlinedIcon}
      id={ref}
      showError={requestData.error}
      footer={
        <Button variant="contained" color="success" onClick={handleSchedule}>
          Schedule Delivery
        </Button>
      }
    >
      <div className="space-y-6">
        <div>
          <SectionLabel>Order details</SectionLabel>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            <Field
              icon={<PersonOutlineIcon sx={iconProps} />}
              label="Customer"
              value={data.Customer}
            />
            <Field
              icon={<NumbersIcon sx={iconProps} />}
              label="Order Number"
              value={data.OrderNumber}
            />
            <Field
              icon={<WorkIcon sx={iconProps} />}
              label="Job Ref"
              value={data["Job Ref"]}
            />
            <div className="sm:col-span-3">
              <Field
                icon={<HomeIcon sx={iconProps} />}
                label="Deliver To"
                value={data["Deliver To"]}
              />
            </div>
          </div>
        </div>

        <div>
          <SectionLabel>Request information</SectionLabel>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <Field
              icon={<PersonOutlineIcon sx={iconProps} />}
              label="Requested by"
              value={requestData?.requestName}
            />
            <Field
              icon={<CalendarMonthIcon sx={iconProps} />}
              label="Date requested"
              value={requestData?.requestDate}
            />
            <div className="sm:col-span-2">
              <Field
                icon={<NoteAltIcon sx={iconProps} />}
                label="Notes"
                value={requestData?.notes ? requestData.notes : "No provided notes"}
              />
            </div>
          </div>
        </div>

        <div>
          <SectionLabel>Schedule date</SectionLabel>
          <DatePicker
            selected={dateSelected}
            minDate={new Date()}
            onChange={(date) => {
              setDate(date);
              setFormattedDate(date.toLocaleDateString("en-US"));
            }}
            className={datePickerClass}
          />
        </div>

        <NotesInput value={notes} onChange={(e) => setNotes(e.target.value)} />
      </div>
    </RequestActionShell>
  );
};

export default ScheduleEarliest;
